<template>
    <div
        class="n4 d-flex align-center"
        :class="reducedSpacing ? 'pl-7' : 'pl-3'"
        :style="reducedSpacing ? 'padding-top: 4px' : 'padding-bottom: 6px; padding-top: 6px'"
    >
        <v-icon v-if="icon" color="white">
            {{ icon }}
        </v-icon>
        <slot>
            <div class="subtitle-2 white--text ml-3">
                {{ title }}
            </div>
        </slot>
        <div
            class="ml-auto mr-7"
            :class="reducedSpacing ? 'mb-1' : ''"
        >
            <v-icon
                color="white"
                @click="$emit('close')"
            >
                mdi-close
            </v-icon>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        icon: {
            type: String,
            default: null
        },
        title: {
            type: String,
            required: true
        },
        reducedSpacing: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {

        return {

        };
    }
};
</script>

<style scoped lang="scss">

</style>
